import React from "react";
import {BrowserRouter as Router, BrowserRouter, Navigate, Route,Routes, useParams} from "react-router-dom";
import {userRoutes} from "../../route";
import {createBrowserHistory} from "history";
//import {useUser} from "../../core/hooks/useUser";
//import StickFooter from "../mobile/stickFooter/index"
//const account = React.lazy(() => import(("../../screens/account/accountScreen")));


const MainNavigator = ()=>{
    const browserHistory = createBrowserHistory();
    return (
        <Router history={browserHistory}>
            <Routes>
                {(userRoutes).map((route, idx) => {
                    return route.component ? (
                        <Route
                            key={idx}
                            path={route.path}
                            exact={route.exact}
                            name={route.name}
                            params={{page:route.page}}
                            element={<route.component page={route.page}/>}
                            />
                    ) :   <Navigate to={'/ru'}/>;
                })}
            </Routes>
        </Router>
    )

}
export default MainNavigator;
